import script from "./kenya-tax-compliance.vue?vue&type=script&setup=true&lang=js"
export * from "./kenya-tax-compliance.vue?vue&type=script&setup=true&lang=js"

import "./kenya-tax-compliance.vue?vue&type=style&index=0&id=17db6e02&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17db6e02"]])

export default __exports__